import Action from "../action/Action.ts";

import { API_PATH_SYNC_CHECK, API_PATH_SYNC_CHECK_POST } from "./SyncCheckConstant.ts";

export const SyncCheckAction = {
    getDetail(token: string, id: number, callback: Function, errorHandler: Function) {
        const url = API_PATH_SYNC_CHECK + "/" + id;
        Action.fetchAuthorizedJson(url, token, "GET", new Headers(), null, callback, errorHandler);
    },
    create(token: string, accommodation_id: number, differ_in_month: number, callback: Function, errorHandler: Function) {
        const url = API_PATH_SYNC_CHECK_POST + "/" + accommodation_id + "/" + differ_in_month;
        Action.fetchAuthorizedJson(url, token, "POST", new Headers(), null, callback, errorHandler);
    },
};
